export const ru = {
    copied: 'Скопировано',
    'copy-error': 'Ошибка при копировании',
    'copy-link': 'Копировать условия в буфер обмена',
    'day-description': {
        one: 'за {count} день',
        some: 'за {count} дня',
        many: 'за {count} дней',
        none: 'за {count} дней'
    },
    'open-popup-text': 'Посмотреть условия',
    'popup-title': 'Условия ретаргетинга'
};
